import type { NotificationPreferenceUpdate } from "@anaconda/core/notification-preferences"
import { wrap } from "@reatom/core"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {
  accountSettingsRequest,
  getNotificationPreferences,
  preferencesSchema,
} from "./account-settings-api"
import { useAccountEmailAuth } from "./use-account-email-auth"

export const notificationPreferenceQueryKey = (userId: string | null) => [
  "account-notification-preferences",
  userId,
]

export function useNotificationPreferences() {
  const { userId, authenticated, bffBaseUrl, getAccessToken } =
    useAccountEmailAuth()
  const client = useQueryClient()
  const key = notificationPreferenceQueryKey(userId)
  const options = { bffBaseUrl, accountId: userId ?? "", getAccessToken }
  const query = useQuery({
    queryKey: key,
    queryFn: () => getNotificationPreferences(options),
    enabled: authenticated && Boolean(userId),
    retry: false,
  })
  const mutation = useMutation({
    mutationFn: async (update: NotificationPreferenceUpdate) =>
      preferencesSchema.parse(
        await wrap(
          accountSettingsRequest(options, "notifications", "PATCH", update),
        ),
      ),
    onMutate: () => ({ key }),
    onSuccess: (data, _variables, context) => {
      client.setQueryData(context.key, data)
    },
  })
  return { query, mutation }
}
